export const ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    EMAIL_AVAILABILITY: '/auth/email-availability',
  },
  USERS: {
    ME: '/users/me',
    ONBOARDING: '/users/me/onboarding',
    NEARBY: '/users/nearby',
  },
  TAGS: {
    LIST: '/tags',
  },
  EVENTS: {
    LIST: '/events',
    BY_ID: (id: string) => `/events/${id}`,
  },
  MATCHES: {
    LIST_ME: (eventoId: string) => `/matches/me/${eventoId}`,
    BY_ID: (id: string) => `/matches/${id}`,
    RESPOND: (id: string) => `/matches/${id}/respond`,
    STATS: (eventoId: string) => `/matches/stats/${eventoId}`,
  },
  CHAT: {
    CONVERSATIONS: '/chat/conversations',
    MESSAGES_LIST: (matchId: string) => `/chat/messages/${matchId}`,
    MESSAGES_SEND: '/chat/messages',
    MESSAGE_DELETE: (id: string) => `/chat/messages/${id}`,
    READ: (matchId: string) => `/chat/messages/${matchId}/read`,
    UPLOAD: '/chat/upload',
  },
  CRM: {
    LIST_ME: '/crm/me',
    BY_ID: (id: string) => `/crm/${id}`,
    STAGE: (id: string) => `/crm/${id}/stage`,
    ACTIVITIES: (id: string) => `/crm/${id}/activities`,
  },
  NOTIFICATIONS: {
    LIST: '/notifications',
    UNREAD_COUNT: '/notifications/unread-count',
    READ: (id: string) => `/notifications/${id}/read`,
    READ_ALL: '/notifications/mark-all-read',
  },
} as const;
